<template>
  <div class="container_checkbox" @click="onSelect">
    <div class="checkbox">
      <img
        src="@/assets/images/CH2/check.png"
        class="size_image"
        v-show="index == isCheck ? true : false"
      />
      <img
        v-show="index != isCheck ? true : false"
        src="@/assets/images/CH2/square.png"
        class="size_image"
      />
    </div>
    <div :class="checkLanguage()">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    text: String,
    index: Number,
    isCheck: Number,
    detectedLanguage: String,
  },
  data() {
    return {
      detectedLanguageProps: "chinese",
    };
  },
  methods: {
    onSelect() {
      this.$emit("returnIndex", this.index);
    },
    checkLanguage: function () {
      if (this.detectedLanguageProps == "chinese") {
        return "text_checkbox font_checkbox fontChinese";
      } else {
        return "text_checkbox font_checkbox";
      }
    },
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.detectedLanguage != undefined) {
      this.detectedLanguageProps = this.detectedLanguage;
    } else {
      this.detectedLanguageProps = "chinese";
    }
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.container_checkbox {
  background-color: #e6efff;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 15px;
}
.size_image {
  width: 50%;
  height: 50%;
}
.checkbox {
  width: 22%;
  display: flex !important;
  justify-content: center !important;
}
.text_checkbox {
  width: 70%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 20px;
}

@media only screen and (min-width: 375px) and (max-width: 415px) {
  .checkbox {
    width: 35%;
    display: flex !important;
    justify-content: center !important;
  }
  .text_checkbox {
    font-size: 18px;
  }
  .title {
    width: 93%;
  }
}
</style>
